import React from 'react'

interface Props {
    value: number
    displaySignAlways: boolean
}
export const formatMoney = (value: number, displaySignAlways: boolean) => {
    let signDisplay = 'auto'
    if (displaySignAlways) {
        signDisplay = 'always'
    }
    const formattedValue = new Intl.NumberFormat('en', {
        style: 'decimal',
        minimumFractionDigits: 2,
        // @ts-ignore
        signDisplay: signDisplay,
    }).format(value)

    return `${formattedValue}`
}
class Money extends React.Component<Props> {
    public static defaultProps = {
        displaySignAlways: false,
    }
    public render() {
        return <span>{formatMoney(this.props.value, this.props.displaySignAlways)}</span>
    }
}

export default Money
